import { type FC } from 'react'
import { TrialTimeline } from '../../Common/TrialTimeline'
import { type DeltaTrialTimelineProps } from '../Timeline/DeltaTrialTimeline'

export const AccountOpeningTimeline: FC<DeltaTrialTimelineProps> = (props) => {
  return <TrialTimeline featureName='Account Opening' {...props} />
}
